import * as api from '../utils/api';

/**
 * Initial setup middleware executed as first before all routes.
 * Responsible for initial user session loading
 */
export default defineNuxtRouteMiddleware(async (to) => {
  const store = useWebsiteStore();

  // Attempt to get user profile if user is logged in
  // Do not get user on login page or payment page
  if (!store.userInfo && isLoggedIn() && to.name !== 'login' && to.name !== 'payment-id') {
    const { data } = await useAsyncData(() => api.getMyProfile());
    store.userInfo = data;
  }
});
